import { Outlet } from 'react-router-dom';
import AdminSidebar from './components/Sidebar';
import AuthGuard from './components/AuthGuard';

export default function AdminLayout() {
  return (
    <AuthGuard>
      <div className="min-h-screen bg-gray-50">
        <AdminSidebar />
        <main className="ml-64 min-h-screen">
          <Outlet />
        </main>
      </div>
    </AuthGuard>
  );
}